export const testimonials = [
  {
    quote:
      'En six mois, nous avons repris la main sur nos achats directs. Les économies ont dépassé l’objectif, mais surtout, nos équipes savent maintenant négocier avec méthode.',
    name: 'Marc D.',
    role: 'Directeur général',
    company: 'ETI industrielle',
  },
  {
    quote:
      'Une vraie experte de la supply chain, très terrain. Elle a su embarquer nos magasins comme notre entrepôt, et nos ruptures ont quasiment disparu.',
    name: 'Sophie L.',
    role: 'Directrice des opérations',
    company: 'Distribution spécialisée',
  },
  {
    quote:
      'Arrivée en management de transition dans un contexte tendu, elle a stabilisé l’équipe achats en quelques semaines et lancé les bons chantiers.',
    name: 'Karim B.',
    role: 'Directeur financier',
    company: 'Groupe de services',
  },
  {
    quote:
      'Pragmatique, transparente et exigeante avec les fournisseurs comme avec nous. Exactement ce dont nous avions besoin pour sécuriser notre sourcing.',
    name: 'Claire M.',
    role: 'Présidente',
    company: 'PME agroalimentaire',
  },
];
